import { ComposedCard, Divider, Stack } from '@eigtech/ui-shared-dave'
import { MeetingStatus, useMeetingStatus } from 'amazon-chime-sdk-component-library-react'
import { CameraSelection } from './DeviceSelection/CameraSelection'
import { MicSelection } from './DeviceSelection/MicSelection'
import { SpeakerSelection } from './DeviceSelection/SpeakerSelection'

export function DevicesControls() {
  const meetingStatusEnum = useMeetingStatus()
  const isInMeeting = meetingStatusEnum === MeetingStatus.Succeeded

  if (!isInMeeting) return null

  return (
    <ComposedCard>
      <Stack divider={<Divider />} spacing="4">
        <CameraSelection />
        <MicSelection />
        <SpeakerSelection />
      </Stack>
    </ComposedCard>
  )
}
